
import React from 'react'
import Loader from 'react-loader-spinner'
import { Modal } from 'react-bootstrap'
import './Spinner.scss'
//import CircularProgress from '@material-ui/core/CircularProgress'
export default class CustomSpinner extends React.Component {
	render() {
		return (
			<div>
				<Modal
					//className='loadingSpinner'
					show={this.props.showModal}
					onHide={this.handleClose}
					animation={false}
				    className='loadingBackdropwithNoBackdrop'
				>

					<Modal.Body className='modalBody noPadding'>
						<div className='verticalMiddle'>
							<Loader type='TailSpin' color='#E39381' height={80} width={80} visible={true} />
							{/* <CircularProgress color='secondary' className='spinnerSize' /> */}
						</div>
					</Modal.Body>
				</Modal>
			</div>
		)
	}
}



// import React from "react";
// import Loader from "react-loader-spinner";
// import "./UserCardSpinner.scss";
// //import CircularProgress from '@material-ui/core/CircularProgress'
// export default class UserCardSpinner extends React.Component {
//   render() {
//     return (
//       <div className="userCardLoader">
//         <div className="userCardSpinnerBackdrop"></div>
//         <div className="userCardSpinner">
//           <Loader
//             type="TailSpin"
//             color="#918d8d"
//             height={80}
//             width={80}
//             visible={true}
//           />
//         </div>
//       </div>
//     );
//   }
// }

